// src/i18n/es/liveBoard.ts
// «Tablero en vivo» (w7.u3) — ruta /live-board, Recepción. Cuatro columnas
// (Pendientes, En el kiosco, Necesitan a alguien, Esperando habitación),
// franja de dispositivos (gris, no rojo, en silencio) e incidencias
// abiertas. Sondea la API cada 15 s; «Actualizar» fuerza una lectura.
export const liveBoard = {
  name: 'Tablero en vivo |||| Tablero en vivo',
  subtitle: 'Quién está esperando, quién está en el kiosco, quién necesita ayuda — ahora mismo',

  threshold: {
    label: 'Aviso a partir de',
    helper: 'Preferencia personal — resalta un kiosco cuando lleva más de este tiempo en el mismo paso.',
  },

  columns: {
    pending: 'Pendientes',
    atDevice: 'En el kiosco',
    atDeviceEmpty: 'Nadie en el kiosco ahora mismo.',
    needsHelp: 'Necesitan a alguien',
    needsHelpEmpty: 'Nadie necesita ayuda ahora mismo.',
    roomNotReady: 'Esperando habitación',
  },

  unknownDevice: 'Dispositivo sin identificar',
  reservation: 'Reserva %{id}',

  signals: {
    blocking_error: 'Error bloqueante',
    handed_to_desk: 'Derivado a mostrador',
  },

  deviceStrip: {
    title: 'Dispositivos',
    empty: 'Sin dispositivos registrados.',
    silentSince: '%{label}: sin señal desde %{relative}',
    silent: '%{label}: sin señal',
    health: {
      up: 'En servicio',
      degraded: 'En servicio con avisos',
      down: 'Fuera de servicio: avería bloqueante',
      maintenance: 'En mantenimiento',
      blocked: 'Bloqueado',
      unknown: 'Sin señal reciente de este dispositivo.',
    },
  },

  todaySoFar: {
    title: 'Hoy hasta ahora',
    // From the hotel's reservations, so it also counts guests who never touch a Roommatik channel.
    due: 'Previstas (según el sistema de reservas del hotel)',
    pre_checked: 'Con pre-check-in',
    not_yet_arrived: 'Aún no llegadas',
    done: 'Completadas',
  },

  incidents: {
    title: 'Incidencias abiertas',
    empty: 'Sin incidencias abiertas.',
    open: 'Abierta',
    acknowledged: 'Reconocida',
  },

  errorsNow: {
    title: 'Trayectos con error ahora',
    empty: 'Sin errores en curso.',
  },

  stamp: {
    updated: 'Actualizado %{relative}',
    noData: 'Sin datos',
  },

  // Verbatim es-ES text from 02-metric-catalogue.md S1.4 — the wire only
  // carries the code (`MetricStampDto.remedies`); same sentences Operación
  // uses (w7.u2, a sibling branch this unit does not share code with).
  remedies: {
    R_FEED: 'Datos no disponibles: este hotel no recibe sus reservas del sistema de reservas del hotel. Active la entrega de reservas →',
    R_OUTBOX: 'No disponible: la entrega de eventos de este dispositivo no es fiable todavía. Actualice el software del kiosco →',
    R_N: 'Muestra insuficiente: menos de 20 casos en el periodo.',
    R_PENDING: 'Pendiente de confirmación del sistema de reservas del hotel.',
    R_EVENTTIME: 'No disponible con la conexión actual: el sistema de reservas de este hotel se consulta periódicamente y no informa la hora de sus eventos.',
    R_PMSFIELD: 'El sistema de reservas de este hotel no informa este dato.',
    R_SIGNAL: 'Sin señal desde hace %{minutes} min.',
    R_MARKER: 'Sin referencia de cadena: menos de tres hoteles con dato.',
    R_NO_BUSINESS_DAY_ROLLOVER: 'Día de negocio no configurado: este hotel no tiene definida la hora de cierre del día.',
  },

  help: {
    title: 'Tablero en vivo',
    description:
      'El tablero de recepción: cuatro columnas con quién está pendiente, en el kiosco, necesitando ayuda o esperando habitación, más la franja de dispositivos y las incidencias abiertas. Se actualiza solo cada 15 segundos; el botón «Actualizar» lo lee al momento.',
    features: {
      columns: '«Pendientes» y «Esperando habitación» muestran solo cuántos son; «En el kiosco» y «Necesitan a alguien» listan cada huésped con su recorrido abierto.',
      deviceStrip: 'Un dispositivo en gris lleva un rato sin dar señal — nunca se marca en rojo por silencio.',
      sound: 'Suena un aviso solo cuando aparece una fila nueva en «Necesitan a alguien», nunca por una que ya estaba.',
    },
    tips: {
      threshold: 'El aviso de minutos es una preferencia personal de su usuario: se guarda en su cuenta y le acompaña en cualquier equipo, pero no es un ajuste del hotel ni lo ven los demás recepcionistas.',
    },
  },
};

export default liveBoard;
